// extracted by mini-css-extract-plugin
export default {"mainContainer":"admin_mainContainer__S1RT1"};